import { neqrawBrand } from "@/assets/brand/integration/brand";
import { actionText } from "./nativeTheme.json";

export { neqrawBrand };

export const brand = {
  primary: neqrawBrand.colors.primary,
  secondary: neqrawBrand.colors.secondary,
  success: neqrawBrand.colors.success,
  accent: neqrawBrand.colors.accent,
  background: neqrawBrand.colors.bg,
  surface: neqrawBrand.colors.surface,
  card: neqrawBrand.colors.card,
  border: neqrawBrand.colors.border,
  light: neqrawBrand.colors.light,
  white: neqrawBrand.colors.white,
  // Compatibility aliases for the small set of already-tokenized screens.
  ink: neqrawBrand.colors.text_dark,
  blue: neqrawBrand.colors.secondary,
  coral: neqrawBrand.colors.accent,
  paper: neqrawBrand.colors.light,
  softGray: neqrawBrand.colors.border,
} as const;

export const surface = {
  primary: brand.surface,
  secondary: brand.background,
  elevated: brand.card,
  brand: brand.primary,
  inverse: brand.ink,
  selected: "rgba(124,58,237,0.18)",
  danger: "rgba(225,29,72,0.14)",
  warning: "rgba(245,158,11,0.14)",
  success: "rgba(16,185,129,0.14)",
  info: "rgba(59,130,246,0.14)",
  overlay: "rgba(11,16,32,0.8)",
} as const;

export const text = {
  primary: brand.light,
  secondary: brand.border,
  muted: "#A8B4C8",
  inverse: brand.white,
  // Light violet for small text on dark surfaces; primary stays canonical for CTAs.
  brand: actionText,
  danger: "#FDA4AF",
  warning: brand.accent,
  info: "#93C5FD",
} as const;

export const border = {
  subtle: brand.card,
  strong: "#94A3B8",
  brand: brand.primary,
  danger: "#E11D48",
} as const;

export const action = {
  primary: brand.primary,
  primaryPressed: "#6D28D9",
  secondary: brand.card,
  disabled: brand.card,
} as const;

export const feedback = {
  success: brand.success,
  warning: brand.accent,
  danger: "#E11D48",
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 48,
} as const;

export const radius = {
  xs: neqrawBrand.radius.xs,
  sm: 8,
  md: 12,
  lg: 16,
  xl: neqrawBrand.radius.xl,
  xxl: neqrawBrand.radius.xxl,
  pill: 999,
} as const;

export const typography = {
  family: {
    regular: "Poppins_400Regular",
    medium: "Poppins_500Medium",
    semibold: "Poppins_600SemiBold",
    bold: "Poppins_700Bold",
    extrabold: "Poppins_800ExtraBold",
    arabicRegular: "Tajawal_400Regular",
    arabicMedium: "Tajawal_500Medium",
    arabicBold: "Tajawal_700Bold",
    arabicExtrabold: "Tajawal_800ExtraBold",
  },
  size: {
    display: 36,
    heading: 28,
    title: 20,
    body: 16,
    caption: 13,
  },
  lineHeight: {
    display: 44,
    heading: 36,
    title: 28,
    body: 24,
    caption: 18,
  },
} as const;

/** @deprecated Compatibility only for screens awaiting the controlled Phase 2 migration. */
export const LEGACY_CURRENT = {
  background: neqrawBrand.colors.bg,
  accent: neqrawBrand.colors.primary,
  card: surface.primary,
  border: border.subtle,
  muted: text.muted,
  text: text.primary,
} as const;
